export enum Colors {
  Primary = 'primary',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}
